export default {
	redDark:  '#C62431',
	red:      '#FA635F',
	redLight: '#FF856A',

	tealDark:  '#00A68C',
	teal:      '#7BD0B8',
	tealLight: '#EFF9F4',

	greyDark:  '#555555',
	grey:      '#5B5C5E',
	greyLight: '#9B9B9B',

	green: '#8ACD46',

	white: '#FFFFFF',
};


// WEBPACK FOOTER //
// ./src/assets/colors.js